import React from 'react'
import classes from './NoEKGPreview.css'

export const NoEKGPreview = props => {
  const {
    height,
  } = props

  return (
    <div
      className={classes.noEKGPreview}
      style={{ height }}
    >
      <div className={classes.text}>
        ECG Preview not available
      </div>
    </div>
  )
}

export default NoEKGPreview



// WEBPACK FOOTER //
// ./src/legacy/components/NoEKGPreview/NoEKGPreview.jsx